module.exports = __webpack_public_path__ + "static/AkkuratLightPro-Regular-40e09906b463089652bc10b2927488e0.woff2";